import { render, staticRenderFns } from "./VolunteerOpp.vue?vue&type=template&id=0c593172&"
import script from "./VolunteerOpp.vue?vue&type=script&lang=js&"
export * from "./VolunteerOpp.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerOpp.vue?vue&type=style&index=0&id=0c593172&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports